import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    tooltipContainer: {
      position: "relative",
      display: "inline-block",

      "&:hover $tooltipText": {
        visibility: "visible",
        opacity: 1,
      },
    },
    tooltipText: {
      visibility: "hidden",
      opacity: 0,
      transition: "opacity 0.3s",
      zIndex: 1500,
      position: "absolute",
      bottom: "100%", // Position above the element
      display: "flex",
      alignItems: "flex-start",
      alignContent: "flex-start",
      maxWidth: "225px",
      width: "max-content",
      padding: "8px",
      borderRadius: "4px",
      backgroundColor: "#0e0e0e",
      color: "#fff",
      boxShadow: "0px 6px 16px 0px rgba(0, 0, 0, 0.12)", // elevation 2
    },
  },
  { name: "N0Tooltip" },
);

export { useStyles };
